import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModeratorService} from '../../resources/services/moderator.service';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'config',
  templateUrl: './config.component.html'
})
export class ConfigComponent implements OnInit {

  form: FormGroup;
  item: any;

  items: any[] = [{
    label: 'MCS (mail)',
    value: 'mail'
  }, {
    label: 'AWS (amazon)',
    value: 'amazon'
  }, {
    label: 'Yandex',
    value: 'yandex'
  }];

  constructor(private modelService: ModeratorService) { }

  ngOnInit(): void {
    this.form = new FormBuilder().group({
      activeBucket: ['', Validators.required],
      internal: [false]
    })
    this.get();
  }

  get() {
    this.modelService.getConfig({}).subscribe(
      (res: any) => {
        this.item = res;
        this.form.patchValue(this.item);
      },
      err => {
        console.log(err);
      }
    );
  }

  onSubmit() {
    let form = this.form;
    setTimeout(() => { form.disable() });
    this.modelService.updateConfig(form.value).pipe(
      finalize(() => {
        form.enable()
      })
    ).subscribe();
  }

}
